
import HeavenItem from './HeavenItem';
import { EVENTS } from '../../../../shared/Events';

class HiGod extends HeavenItem {
  constructor(parentCont, data) {
    super(data);

    // vars
    this.parentCont = parentCont;
    this.hideDelay = null;

    this.inPlaying = false;
    this.doneIn = false;
    this.doneOut = false;

    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.sprite = new PIXI.Sprite.fromFrame('god.png');
    this.sprite.anchor.x = 93 / 185;
    this.sprite.anchor.y = 82 / 134;
    this.parentCont.addChild(this.sprite);
    this.sprite.visible = false;

    // signals
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType, params) {
    switch (sgType) {
      case EVENTS.MOVE_TO_HEAVEN_END:
        if (!this.doneIn) {
          this.inPlaying = true;
          this.doneIn = true;
          aScene.sndManager.playSfx('buh-prilet-bez-tonu');
          this.showGod(5000);
        }
        break;
      case EVENTS.MOVE_TO_TOWN_START:
        if (!this.doneOut && !this.inPlaying) {
          this.doneOut = true;
          aScene.sndManager.stopItemSfx('god');
          aScene.sndManager.playSfx(`buh-odlet-${Math.round(Math.random())}-bez-tonu`);
          this.showGod(2000);
        }
        break;
      case EVENTS.SHOW_GOD:
        this.showGod(params);
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Show
  // --------------------------------------------------------------

  showGod(hideDelay) {
    clearTimeout(this.hideDelay);
    TweenMax.killTweensOf(this.sprite);
    TweenMax.killTweensOf(this.sprite.scale);

    this.sprite.alpha = 0;
    this.sprite.visible = true;
    this.sprite.scale.x = 0.3;
    this.sprite.scale.y = 0.2;

    TweenMax.to(this.sprite, 0.4, {
      alpha: 1,
    });
    TweenMax.to(this.sprite.scale, 0.5, {
      x: 1,
      y: 1,
      ease: Back.easeOut,
    });

    // hide delay
    this.hideDelay = setTimeout(() => {
      this.hideGod();
    }, hideDelay);
  }

  hideGod() {
    this.inPlaying = false;
    TweenMax.to(this.sprite, 0.6, {
      alpha: 0,
    });
    TweenMax.to(this.sprite.scale, 0.6, {
      x: 1.4,
      y: 1.4,
      ease: Sine.easeIn,
      onComplete: this.hideEnd,
      onCompleteScope: this,
    });
  }

  hideEnd() {
    this.sprite.visible = false;
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    super.loopUp();
    this.sprite.x = this.position.item.x;
    this.sprite.y = this.position.item.y;
  }
}


export default HiGod;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/HiGod.js